import React from 'react';
import Main from '../../components/Main';
import ExecByPractice from '../../components/ExecByPractice';

// Practice Subpage of OurLeaders Page

const Practice = () => {
  return (
    <div>
      <Main componentList={[
      <div>
        <ExecByPractice />
     </div>]} />
    </div>
  );
};

export default Practice;